import React from 'react';
import { DrillDownEvolucaoComprasData } from '../../Pages/AnalisesCompras/types';
import GenericTransactionDrillDown from './GenericTransactionDrillDown';

interface EvolucaoComprasDrillDownProps {
  data: DrillDownEvolucaoComprasData | any;
}

const EvolucaoComprasDrillDown: React.FC<EvolucaoComprasDrillDownProps> = ({ data }) => {
  return (
    <GenericTransactionDrillDown 
      data={data}
      transactionType="compras"
    />
  );
};

export default EvolucaoComprasDrillDown; 